<script>
    import { getContext } from "svelte";
    const { height } = getContext("LayerCake");

    export let ctx;
    export let spike;
    export let length;
    export let legend_rect_spacing = 30;
    $: padding = 20 + 3;
</script>

<path
    class="spike legend-spike"
    fill={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    stroke={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    d={spike(length(400))}
    transform={`translate(${padding}, ${$height})`}
/>

<path
    class="spike legend-spike"
    fill={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    stroke={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    d={spike(length(1000))}
    transform={`translate(${padding + legend_rect_spacing}, ${$height})`}
/>

<path
    class="spike legend-spike"
    fill={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    stroke={ctx["type"] == "tribe"
        ? "var(--colorScale100)"
        : "var(--gray-40)"}
    d={spike(length(1600))}
    transform={`translate(${padding + legend_rect_spacing * 2}, ${$height})`}
/>

<style lang="scss">
    .spike {
        fill-opacity: 0.6;
        stroke-opacity: 0.9;
        transition: fill-opacity var(--transition),
            stroke-opacity var(--transition);
        pointer-events: none;
    }
</style>
